import React, { lazy, Suspense, useState } from "react";

const WorkspaceProjectTool = lazy(() => import("./WorkspaceProjectTool"));

export default function WorkspaceProjects({ project, active = true, requestJson, baseUrl = "", user }) {
  const [visited, setVisited] = useState(active);
  if (active && !visited) setVisited(true);
  if (!project?.id || !project?.slug) return <p role="alert">Project access is unavailable.</p>;
  if (!visited && !active) return null;
  return (
    <Suspense fallback={active ? <p role="status">Loading projects...</p> : null}>
      <WorkspaceProjectTool key={`${project.slug}:${project.id}`} project={project} active={active} requestJson={requestJson} baseUrl={baseUrl} user={user} />
    </Suspense>
  );
}
